import { AppDateTimesSnapshot, ConfiguredDataDefinition } from '@/apps/timeSeriesViewer';

export class TrendDataDefinition {
  constructor(
    public appDateTimes: AppDateTimesSnapshot,
    public configuredDataDefinitions: ConfiguredDataDefinition[],
    public requestId: string
  ) {}
}
